import { RouteType } from "../../constants/RouteType";
import { AuthService } from "../auth/AuthService";
import { msgTypes } from "../../constants/msgTypes";
import { ForgotPasswordModel } from "../../model/utilModels/ForgotPasswordModel";
import { PaginatorModel } from "../../model/utilModels/PaginatorModel";
import { URL } from "node:url";
import ApiUrl from "./ApiUrl";
import axios from "axios";
import { Auth } from "../auth/Auth";
import { json } from "node:stream/consumers";
import { LocalStorageService } from "../auth/LocalStorageService";
import { ChangePasswordModel } from "../../model/utilModels/ChangePasswordModel";

export class UtilService {
  static getCountry = async () => {
    const url = RouteType.MASTER + RouteType.GET_COUNTRY;
    const response = await AuthService.postCryptoRequest(
      url,
      msgTypes.EMPTY_STR
    );
    return response;
  };

  static getState = async (requestBody: {}) => {
    const payload = {
      countryId: requestBody,
    };
    const url = RouteType.MASTER + RouteType.GET_STATE;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );
    return response;
  };
  static getCity = async (requestBody: {}) => {
    const payload = {
      stateId: requestBody,
    };

    const url = RouteType.MASTER + RouteType.GET_CITY;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );
    return response;
  };
  static login = async (requestBody: {}) => {
    const url = RouteType.AUTH + RouteType.LOGIN;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };

  static roleAndPermissoin = async () => {
    const url = RouteType.AUTH + RouteType.PERMISSION_LIST;
    const response = await AuthService.postCryptoRequest(
      url,
      msgTypes.EMPTY_STR
    );
    return response;
  };

  static createNewPassword = async (requestBody: {}) => {
    const url = RouteType.AUTH + RouteType.CREATE_PASSWORD;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };

  static forgotPassword = async (authData: ForgotPasswordModel) => {
    const url = RouteType.AUTH + RouteType.FORGOT_PASSWORD;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(authData)
    );
    return response;
  };

  static getAirport = async () => {
    const url = RouteType.MASTER + RouteType.AIRPORT_LIST;
    const response = await AuthService.postCryptoRequest(
      url,
      msgTypes.EMPTY_STR
    );
    return response;
  };

  static createUser = async (requestBody: {}) => {
    const url = RouteType.CREATE_USER;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };

  static getUserList = async (param?: {}) => {
    const url = RouteType.USER_LIST;
    const response = await AuthService.getCryptoRequest(url, {
      params: param,
    });
    return response;
  };

  static EditUser = async (requestBody: {}, id: string) => {
    const url = RouteType.CREATE_USER + "/" + id;
    const response = await AuthService.patchCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };

  static getCompany = async (branch?: string | {}) => {
    const url = RouteType.AUTH + RouteType.COMPANY_LIST;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(branch)
    );
    return response;
  };

  static getUserName = async (payload: {}) => {
    const url = RouteType.USER_NAME;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );
    return response;
  };

  static getBusinessList = async (filter?: {}) => {
    const url = RouteType.BUSINESS_LIST + "/";
    const response = await AuthService.getCryptoRequest(url, {
      params: filter,
    });
    return response;
  };
  static createRole = async (payload?: {}) => {
    const url = RouteType.CONTROL_PANEL + RouteType.CREATE_ROLE;
    const response = AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );
    return response;
  };
  static getRoleList = async () => {
    const payload = {};
    const url = RouteType.CONTROL_PANEL + RouteType.ROLE;
    const response = AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );
    return response;
  };

  static getCountryCode = async () => {
    const url = RouteType.MASTER + RouteType.COUNTRY_CODE;
    const payload = {};
    try {
      const response = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return response; // Return only data instead of full response
    } catch (error) {
      console.error("Error fetching flight rates:", error);
      throw error; // Ensure errors are handled properly
    }
  };

  static fetchCities = async (query: string) => {
    const apiPath = `${RouteType.MASTER}${
      RouteType.HOTEL_CITY
    }/?query=${encodeURIComponent(query)}`;

    try {
      const response = await AuthService.getCryptoRequest(apiPath);
      return response;
    } catch (error) {
      console.error("Error fetching cities:", error);
      return null;
    }
  };
  static flightBooking = async (payload: any) => {
    try {
      const response = await AuthService.postCryptoRequest(
        RouteType.FLIGHT_BOOKING,
        JSON.stringify(payload)
      );
      return response;
    } catch (error) {
      console.error("Error fetching flightBooking", error);
      return null;
    }
  };
  static getCoupen = async (payload: any) => {
    try {
      const response = await AuthService.postCryptoRequest(
        RouteType.COUPON_LIST,
        JSON.stringify(payload)
      );
      return response;
    } catch (error) {
      console.error("Error fetching hotel list:", error);
      return null;
    }
  };

  static ApplyCoupen = async (payload: any) => {
    try {
      const response = await AuthService.postCryptoRequest(
        RouteType.APPLY_COUPON,
        JSON.stringify(payload)
      );
      return response;
    } catch (error) {
      console.error("Error fetching hotel list:", error);
      return null;
    }
  };

  static paymentHold = async (payload: any) => {
    const url = RouteType.FUND + RouteType.HOLD;
    try {
      const response = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      console.log("Response from paymentHold:", response);
      return response.data;
    } catch (error) {
      console.error("Error fetching paymentHold", error);
      return null;
    }
  };
  static captureTransaction = async (payload: any) => {
    const url = RouteType.FUND + RouteType.CAPTURE;
    try {
      const response = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching captureTransaction", error);
      return null;
    }
  };
  static bookingFail = async (payload: any) => {
    const url = RouteType.FUND + RouteType.BOOKING_FAIL;
    try {
      const response = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return response;
    } catch (error) {
      console.error("Error fetching bookingFail", error);
      return null;
    }
  };
  static paymentFailByPG = async (payload: any) => {
    const url = RouteType.FUND + RouteType.FAIL_GATEWAY;
    try {
      const response = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return response;
    } catch (error) {
      console.error("Error fetching paymentFailByPG", error);
      return null;
    }
  };

  // static fetchHotelBookingList = async (requestBody: PaginatorModel) => {
  //   const url = RouteType.HOTEL_BOOKING_LIST + "/bookings";
  //   const response = await AuthService.getCryptoRequest(
  //     url,
  //     JSON.stringify(requestBody)
  //   );
  //   return response;
  // };

  static fetchHotelBookingList = async (requestBody: PaginatorModel) => {
    const url = RouteType.HOTEL_BOOKING_LIST + "/bookings";
    const response = await AuthService.getCryptoRequest(url);

    return response;
  };

  static downloadTicket = async (txnId: string) => {
    const token = await LocalStorageService.getToken();
    const baseUrl = ApiUrl.baseUrl + RouteType.DOWNLOAD_INVOICE;
    const url = baseUrl + txnId;
    console.log("url", url);
    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  };
  static downloadHotelTicket = async (txnId: string) => {
    const token = await LocalStorageService.getToken();
    const baseUrl = ApiUrl.baseUrl + RouteType.DOWNLOAD_INVOICE;
    const url = baseUrl + txnId + "/";
    console.log("url", url);
    const response = await axios.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  };

  static createCommission = async (requestBody: any) => {
    const url = RouteType.COMMISSION + RouteType.CATEGORIES_LIST;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );

    return response;
  };
  static commissionRule = async (requestBody: {}) => {
    const url = RouteType.COMMISSION + RouteType.FLIGHT_COMMISSION;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );

    return response;
  };

  static categoriesList = async () => {
    const url = RouteType.COMMISSION + RouteType.CATEGORIES_LIST + "/";
    const response = await AuthService.getCryptoRequest(url);

    return response;
  };
  static hotelCategoriesList = async () => {
    const url = RouteType.COMMISSION + RouteType.HOTEL_CATEGORIES_LIST + "/";
    const response = await AuthService.getCryptoRequest(url);

    return response;
  };
  static calculateFlightCommission = async (payload: {}) => {
    const url =
      RouteType.COMMISSION +
      RouteType.FLIGHT_COMMISSION +
      RouteType.CALCULATE_COMMISSION;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );

    return response;
  };

  static sendWelcomeEmail = async (payload: {}) => {
    const url = RouteType.AUTH + RouteType.EMAIL;

    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );

    return response;
  };
  static updateFlightCommission = async (payload: any, id: number | null) => {
    const url = RouteType.COMMISSION + RouteType.FLIGHT_COMMISSION + "/" + id;

    const response = await AuthService.patchCryptoRequest(
      url,
      JSON.stringify(payload)
    );

    return response;
  };
  static getFlightCommissionData = async (id: number | null) => {
    try {
      const url =
        RouteType.COMMISSION + RouteType.FLIGHT_COMMISSION + "/?category=" + id;
      const response = await AuthService.getCryptoRequest(url);
      return response;
    } catch (error) {
      console.error("Error fetching flight commission data:", error);
      return null;
    }
  };
  static removeFlightCommissionData = async (id: number | null) => {
    try {
      const url = RouteType.COMMISSION + RouteType.FLIGHT_COMMISSION + "/" + id;
      const response = await AuthService.deleteCryptoRequest(url);
      return response;
    } catch (error) {
      console.error("Error fetching flight commission data:", error);
      return null;
    }
  };
  static getFlightCommissionInfo = async (params: any) => {
    try {
      const url = RouteType.COMMISSION + RouteType.FLIGHT_COMMISSION;
      const response = await AuthService.getCryptoRequest(url, {
        params: params,
      });
      return response;
    } catch (error) {
      console.error("Error fetching flight commission data:", error);
      return null;
    }
  };

  static tempcategory = async (id: number | null) => {
    try {
      const url =
        RouteType.COMMISSION + RouteType.FLIGHT_COMMISSION + "/by-category";
      const response = await AuthService.postCryptoRequest(
        url,
        JSON.stringify({ category_id: id })
      );
      return response;
    } catch (error) {
      console.error("Error fetching flight commission data:", error);
      return null;
    }
  };

  static createTopUpRequest = async (payload: {}) => {
    const url = RouteType.FUND + RouteType.TOPUP_REQUEST;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );

    return response;
  };
  static verifyUserOtp = async (id: string, payload: {}): Promise<any> => {
    const url =
      RouteType.FUND +
      RouteType.TOPUP_REQUEST +
      "/" +
      id +
      RouteType.TRANSITION;

    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(payload)
    );

    return response;
  };

  static resendUserOtp = async (id: string, payload: {}) => {
    try {
      const url =
        RouteType.FUND +
        RouteType.TOPUP_REQUEST +
        "/" +
        id +
        RouteType.TRANSITION;
      const response = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );

      return response;
    } catch (error) {
      console.log("error", error);
    }
  };
  static getTopupRequestList = async (params?: {}) => {
    try {
      const url = RouteType.FUND + RouteType.TOPUP_REQUEST;
      const response = await AuthService.getCryptoRequest(url, {
        params: params,
      });

      return response;
    } catch (err: any) {
      if (err.name === "AbortError") {
        console.log("Request aborted");
      } else {
        console.error(err);
      }
    }
  };
  static getBusinessName = async () => {
    const url = RouteType.BUSINESS_LIST + "/?fields=id,businessName";
    const response = await AuthService.getCryptoRequest(url);
    return response;
  };
  static getAirlineList = async (queries: string) => {
    const apiPath = `${RouteType.MASTER}${
      RouteType.AIRLINE
    }/?name=${encodeURIComponent(queries)}`;

    const response = await AuthService.getCryptoRequest(apiPath);

    return response;
  };
  static getCountryCodeList = async () => {
    const apiPath = `${RouteType.MASTER}${RouteType.LOCATION}${RouteType.COUNTRIES}`;

    const response = await AuthService.getCryptoRequest(apiPath);

    return response;
  };

  static getOriginCodeByCountry = async (queries: string) => {
    const apiPath = `${RouteType.MASTER}${RouteType.LOCATION}${
      RouteType.BY_COUNTRY
    }/?country=${encodeURIComponent(queries)}`;

    const response = await AuthService.getCryptoRequest(apiPath);

    return response;
  };
  static editTopupRequestByCorporate = async (payload: any, id: any) => {
    try {
      const url = RouteType.FUND + RouteType.TOPUP_REQUEST + "/" + id;
      const res = await AuthService.patchCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return res;
    } catch (error) {
      console.log("error inside edit top up request", error);
    }
  };
  static editCorporate = async (payload: any, id: any) => {
    try {
      const url = RouteType.CORPORATES + "/" + id;
      const res = await AuthService.patchCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return res;
    } catch (error) {
      console.log("error inside edit top up request", error);
    }
  };

  static getBookings = async (params: {}) => {
    try {
      const url = RouteType.FLIGHT + RouteType.BOOKINGS;
      const res = await AuthService.getCryptoRequest(url, {
        params: params,
      });
      return res;
    } catch (error) {
      console.log("error inside getBookings", error);
    }
  };
  static sendTicketViaMail = async (payload: {}) => {
    try {
      const url = RouteType.FLIGHT + RouteType.RESEND_TICKET;
      const res = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return res;
    } catch (error) {
      console.log("error inside getBookings", error);
    }
  };
  static sendHotelTicketViaMail = async (payload: {}) => {
    try {
      const url = RouteType.HOTEL_TICKET;
      const res = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return res;
    } catch (error) {
      console.log("error inside getBookings", error);
    }
  };

  static createCoupon = async (payload: {}) => {
    try {
      const url = RouteType.COUPON + RouteType.CREATE;
      const res = await AuthService.postCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return res;
    } catch (error) {
      console.log("Error in createCoupon:", error);
      throw error;
    }
  };
  static editCoupon = async (payload: {}, id: string) => {
    try {
      const url = RouteType.COUPON + "/" + id;
      const res = await AuthService.patchCryptoRequest(
        url,
        JSON.stringify(payload)
      );
      return res;
    } catch (error) {
      console.log("Error in createCoupon:", error);
      throw error;
    }
  };

  static getCouponList = async (params?: {}) => {
    const url = RouteType.Coupon_LIST;
    const response = await AuthService.getCryptoRequest(url, {
      params: params,
    });
    console.log("getCouponList", response);
    return response;
  };
  static deleteCoupon = async (id: string) => {
    const url = RouteType.COUPON + "/" + id;
    const response = await AuthService.deleteCryptoRequest(url);
    console.log("deleteCouponList", response);
    return response;
  };

  static changePassword = async (requestBody: {}) => {
    const url = RouteType.AUTH + RouteType.CHANGE_PASSWORD;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };

  static AdminUser = async (requestBody: {}) => {
    const url = RouteType.ADMIN_USER;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };

  static getSuperAdminUser = async (params: {}) => {
    const url = RouteType.ADMIN_USER;
    const response = await AuthService.getCryptoRequest(url, {
      params: params,
    });
    return response;
  };
  static EditSuperAdminUser = async (requestBody: {}, id: string) => {
    const url = RouteType.ADMIN_USER + "/" + id;
    const response = await AuthService.patchCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };
  static fetchBalance = async () => {
    const url = RouteType.FUND + RouteType.AVAILABLE_BALANCE;
    const response = await AuthService.getCryptoRequest(url);
    return response;
  };

  static CorporatePostpaidAccount = async (requestBody: {}) => {
    const url = RouteType.CORPORATE_POSTPAID_ACCOUNT;
    const response = await AuthService.postCryptoRequest(
      url,
      JSON.stringify(requestBody)
    );
    return response;
  };

  static getPostpaidAccountList = async (params: {}) => {
    const url = RouteType.CORPORATE_POSTPAID_ACCOUNT_LIST;
    const response = await AuthService.getCryptoRequest(url, {
      params: params,
    });
    return response;
  };
  static getDashboardAnalyticsForSuperAdmin = async () => {
    const url = RouteType.DASHBOARD + RouteType.ANALYTICS;
    const response = await AuthService.getCryptoRequest(url);
    return response;
  };
  static getDashboardAnalyticsForCorporate = async () => {
    const url = RouteType.DASHBOARD + RouteType.USER;
    const response = await AuthService.getCryptoRequest(url);
    return response;
  };

  static getCurrency = async () => {
    const url = RouteType.MASTER + RouteType.CURRENCIES;
    const response = await AuthService.getCryptoRequest(url);
    return response;
  };
}
